import { useState } from 'react';
import {courseInfo, exampleData} from './course-data';
import { matchingTable } from './matchingTable';
import { getCourseLink } from './getCourseLink';

export const useCourseData = () => {
	const [courseData] = useState(() => {
		if (typeof process.env?.NODE_ENV !== 'undefined' && process.env?.NODE_ENV === 'development' && window.location.hostname.includes('localhost')) {
			console.warn('Using example course data');

			const type = localStorage.getItem('course-info-type');
			const specificCourseData = type in exampleData ? exampleData[type] : (window.BILBAO_DATA ?? {});

			return {...courseInfo, ...specificCourseData};
		}
		return window.BILBAO_DATA ?? null;
	});

	const courseLink = getCourseLink(matchingTable, courseData.trainingTypeShort);
	if (courseLink !== null) courseData.iliasCourseLink = courseLink;
	return courseData;
};
